import Button from 'shared/ui/button/button';
import { Modal } from 'shared/ui/modal/modal';
import cls from './store-modal.module.scss';
import { useTranslation } from 'hooks/api/useTranslation';
import { StoreModalProps } from './store-modal.types';

export const StoreModal: React.FC<StoreModalProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  return (
    <Modal isOpen={isOpen} onClose={onClose} className={cls.storeModal}>
      <h2>{t('toBuyLicensesTitle')}</h2>
      <p>{t('toBuyLicenses')}</p>
      <Button onClick={onClose} className={cls.closeBtn}>
        {t('close')}
      </Button>
    </Modal>
  );
};
